import { motion } from 'motion/react';
import { financePartners } from '@/mocks/homeData';

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.1, ease: 'easeOut' },
  }),
};

export default function FinanceSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="inline-block bg-primary-100 text-primary-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
            Easy EMI Available
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Finance Partners
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Buy your dream phone today with flexible EMI plans from India&apos;s most trusted finance partners. Minimal documentation, quick approval.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {financePartners.map((partner, index) => (
            <motion.div
              key={partner.id}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-60px' }}
              variants={cardVariants}
              whileHover={{ y: -8, scale: 1.02, transition: { duration: 0.25 } }}
              className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8 text-center hover:border-accent-300 transition-all duration-300 cursor-default shadow-sm hover:shadow-lg"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-full">
                <i className={`${partner.icon} text-2xl md:text-3xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2">
                {partner.name}
              </h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {partner.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10 md:mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap"
        >
          <div className="flex items-center gap-2 text-foreground-600 text-sm md:text-base">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-line text-accent-500"></i>
            </span>
            Zero Down Payment Plans Available
          </div>
          <div className="hidden sm:block w-px h-5 bg-background-300"></div>
          <div className="flex items-center gap-2 text-foreground-600 text-sm md:text-base">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-time-line text-accent-500"></i>
            </span>
            Approval in 30 Minutes
          </div>
        </motion.div>
      </div>
    </section>
  );
}